import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';

export default function PoliticaPrivacidade() {
  useEffect(() => {
    document.title = 'Politica de Privacidade - ClubdoCupom.com';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Politica de privacidade do ClubdoCupom.com. Nao somos afiliados. Nao armazenamos dados de pagamento. Sua seguranca e nossa prioridade.');
    return () => {
      document.title = 'ClubdoCupom.com - O Canal Oficial do Desconto Direto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex items-center justify-between">
          <Link to="/" className="text-xl sm:text-2xl font-black text-slate-900" data-testid="privacidade-logo">
            ClubdoCupom<span className="text-amber-500">.com</span>
          </Link>
          <Link to="/" className="text-xs sm:text-sm text-slate-600 hover:text-slate-900 transition-colors font-medium" data-testid="privacidade-back-link">
            Voltar ao inicio
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-4xl sm:text-5xl font-black text-slate-900 mb-8" data-testid="privacidade-title">Politica de Privacidade</h1>

          <div className="prose prose-slate prose-lg max-w-none">
            <p className="text-lg text-slate-700 leading-relaxed mb-6" data-testid="privacidade-text-main">
              O ClubdoCupom.com respeita sua privacidade. Coletamos apenas cookies de navegação para melhorar sua experiência. Esclarecemos que NÃO somos um site de afiliados; não recebemos comissões sobre suas compras. Somos uma vitrine tecnológica para lojistas parceiros. Não armazenamos dados de pagamento ou informações sensíveis dos usuários finais. Toda transação financeira ocorre diretamente no ambiente seguro do lojista escolhido.
            </p>

            <div className="space-y-6 mt-10">
              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                <h2 className="text-lg font-bold text-slate-900 mb-2">Coleta de Dados</h2>
                <p className="text-slate-700">Utilizamos apenas cookies essenciais de navegacao e dados de autenticacao (via Google OAuth) para proporcionar uma experiencia personalizada. Nenhuma informacao e compartilhada com terceiros.</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                <h2 className="text-lg font-bold text-slate-900 mb-2">Pagamentos</h2>
                <p className="text-slate-700">Todas as transações financeiras de assinaturas são processadas exclusivamente pelo Stripe, em ambiente seguro e certificado. O ClubdoCupom.com não armazena dados de cartão de crédito.</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                <h2 className="text-lg font-bold text-slate-900 mb-2">Modelo de Negocio</h2>
                <p className="text-slate-700">Reafirmamos: o ClubdoCupom.com NAO e um site de afiliados. Nao recebemos comissoes sobre vendas. Nosso modelo e baseado exclusivamente em assinaturas de lojistas que desejam divulgar seus cupons.</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
